import React from 'react';

import { Badge as RadixBadge } from '@radix-ui/themes';
import classNames from 'classnames';

import { getFlyToRadixColor, renderIcon } from '../utils';
import {
  BadgeProps,
  sizeToClassName,
  variantClassName,
  variantToRadixVariantMap,
} from './Badge.types';

function Badge({
  size = '1',
  color = 'accent',
  radius = 'large',
  variant = 'outline',

  iconStart,
  iconEnd,
  iconStartSize = 12,
  iconEndSize = 12,

  hoverable,

  children,
  className,
  ref,
  ...props
}: BadgeProps & { ref?: React.Ref<HTMLDivElement> }) {
  return (
    <RadixBadge
      color={getFlyToRadixColor(color)}
      size={size}
      variant={variantToRadixVariantMap[variant]}
      className={classNames(
        className,
        sizeToClassName[size],
        variantClassName[variant],
        'flex items-center gap-fly-2',
        hoverable && 'hover:text-(--accent-12) active:text-(--accent-12)'
      )}
      {...props}
      ref={ref}
    >
      {iconStart && <div>{renderIcon(iconStart, iconStartSize)}</div>}
      {children}
      {iconEnd && <div>{renderIcon(iconEnd, iconEndSize)}</div>}
    </RadixBadge>
  );
}

export { Badge };
